import { Route } from "react-router-dom";
import UserCreate from "./pages/UserCreate";
import UserList from "./pages/UserList";

/**
 * This will return all routes for the specific module
 */
const MODULE_ROUTE = "user"; 
const UserRoute = [
    <Route path={`${MODULE_ROUTE}`} element={<UserList />} key={`${MODULE_ROUTE}_index`} />,
    <Route path={`${MODULE_ROUTE}/create`} element={<UserCreate />}  key={`${MODULE_ROUTE}_create`}  />,
    <Route path={`${MODULE_ROUTE}/update/:id`} element={<UserCreate />} key={`${MODULE_ROUTE}_edit`} />,
  ];

export default UserRoute;